<template>
  <div>
    <Header />
    <div class="container pt-4">
      <div class="row">
        <div class="col-12 cookie">
          <h1>Cookie Policy</h1>

          <p>Below is our cookies policy usage on this website.</p>
          <p>By accessing the Website, you agree that this Cookie Policy will apply whenever you access the Website on any device.</p>
          <p>Any changes to this policy will be posted here. We reserve the right to vary this Cookie Policy from time to time and such changes shall become effective as soon as they are posted. Your continued use of the Website constitutes your agreement to all such changes.</p>

          <h2>Cookies Introduction</h2>
          <p>Our website uses several cookies. A cookie is a small file of letters and numbers that we put on your device. These cookies allow us to distinguish you from other visitors of our website which helps us to provide the best user experience when browsing our site, and also allows us to improve our site.</p>
          <p>Our site uses the following types of cookie:</p>
          <ul>
            <li><span class="bold">Analytics Cookies</span>
              <p>Analytics cookies allow us to report on the number of people visiting our website, what pages they visit, and how they arrived on our site. This information is collected anonymously and is only use to gather feedback in order to make improvements to our site.</p>
              <p>We use Google Analytics for this functionality. You can find out more about Google Analytics at the following page: <a href="https://policies.google.com/technologies/partner-sites" target="_blank">https://policies.google.com/technologies/partner-sites</a></p>
            </li>
            <li><span class="bold">Functional Cookies</span>
              <p>Functional cookies are essential to allow our website to function correctly. We use them to distinguish you from other users of our site in order to provide you with the best possible user experience and to improve security.</p>
            </li>
            <li><span class="bold">Marketing & Advertising Cookies</span>
              <p>We use re-marketing cookies via Google and Bing to serve more relevant adverts on third-party sites to users that have visited our site in the past.</p>
              <p>You can opt out of re-marketing by setting your ad preferences with Google at the following page: <a href="http://www.google.com/ads/preferences" target="_blank">http://www.google.com/ads/preferences</a> and Bing <a href="https://privacy.microsoft.com/en-gb/privacystatement" target="_blank">https://privacy.microsoft.com/en-gb/privacystatement</a></p>
            </li>
          </ul>
          <p>This website uses cookies, as almost all websites do, to help provide you with the best experience we can. Cookies are small text files that are placed on your computer or mobile when you browse websites.</p>
          <p>Our Cookies help:</p>
          <ul>
            <li>traffic logs to identify which pages are being used</li>
          </ul>
          <p>We do not use cookies to:</p>
          <ul>
            <li>collect any personal identifiable information(without your express permission);</li>
            <li>collect any sensitive information (without your express permission);</li>
            <li>pass data to advertising networks;</li>
            <li>pass personally identifiable data to third parties;</li>
            <li>pay sales commissions.</li>
          </ul>
          <p>You can learn more about all the cookies we use below.</p>

          <h2>Allowing us to use cookies</h2>
          <p>If the settings on your software that you are using to view this website (your browser) are adjusted to accept cookies we take this, and your continued use of our website to mean that you are fine with this. Should you wish to remove or not use cookies from our site you can learn how to do this below, however doing so will likely mean that our site will not work, as you would expect.</p>
          <p>We use traffic log cookies to identify which pages are being used. This helps us analyse data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.</p>

          <h2>Anonymous visitor statistics cookies</h2>
          <p>We use cookies to compile anonymous visitor statistics such as how many people have visited our website, what type of technology they are using (e.g Mac or Windows which help to identify when our site isn't working as it should for particular technologies), how long they spend on the site, what page they look at etc. This helps us to continuously improve our website. These so called analytic programs also tell us if, on an anonymous basis, how people reached this site (e.g from a search engine).</p>
          <p>To disable Google Analytics, visit this tool <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a></p>

          <h2>Turning cookies off</h2>
          <p>Most modern browsers allow you to control your cookie settings. You can disable them completely by editing your browser settings, however in doing this you may be limiting the functionality that is displayed on our website and also a large population of websites on the Internet that use cookies to serve their content.</p>
          <p>To learn how to disable cookies on browsers please click here <a href="http://support.google.com/accounts/bin/answer.py?hl=en&answer=61416" target="_blank">http://support.google.com/accounts/bin/answer.py?hl=en&answer=61416</a></p>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '../../Sections/Footer'
import Header from '../../Sections/Header'

export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
  .cookie {
    margin-top: 100px;
    margin-bottom: 40px;
    h1 {
      margin-bottom: 2rem;
    }

    h2 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
    }

    table {
      width: 50%;
      margin-left: 10%;
      margin-bottom: 1rem;

      @media (max-width: 599px) {
        width: 100%;
        margin-left: 0;
      }

      tr {
        word-break: break-word;
      }

      td {
        padding: 0.5rem;
        border: 1px solid;
      }

      td:first-of-type {
        min-width: 30%;
      }
    }

    .bold {
      font-weight:bold;
    }

  }
</style>